const miniScanList = [
  { value: "MS09", label: "Anxiety", description: "Probes into energetic imbalances linked to anxiety symptoms." },
  { value: "MS04", label: "Blood Sugar Balance", description: "Assesses factors affecting blood sugar regulation and stability." },
  { value: "MS01", label: "Grey Hair", description: "Identifies potential underlying causes of gray hair." },
  { value: "MS06", label: "Hair Loss", description: "Scans for potential causes of hair loss or thinning." },
  { value: "MS03", label: "Headaches", description: "Investigates possible triggers and imbalances associated with headaches." },
  { value: "MS05", label: "Hypertension", description: "Examines energetic aspects related to high blood pressure." },
  { value: "MS07", label: "Iron Deficiency", description: "Detects imbalances that may indicate iron deficiency." },
  { value: "MS08", label: "Sleep Disturbances", description: "Identifies disruptions in sleep patterns and potential causes." },
  { value: "MS02", label: "Tinnitus", description: "Explores energetic imbalances contributing to tinnitus or ringing in the ears." },
];

export function getMiniScanLabel(value) {
  const scanItem = miniScanList.find(item => item.value === value);
  return scanItem ? scanItem.label : null;
}

export { miniScanList };